import React from 'react';
import styled from 'styled-components';
import Select from '../../../../components/Select/SelectFilter';
import Input from '../../../../components/Input';
import { I18n } from 'react-redux-i18n';

const PreparationFiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  height: 100%;

  > * {
    width: 100%;
  }

  background-color: rgba(173, 181, 189, 0.05);
  padding: 20px;
  padding-top: 30px;
  margin-bottom: 50px;

  :not(:last-children) {
    margin-right: 45px;
  }

  @media (max-width: 1300px) and (min-width: 846px) {
    display: grid;
    grid-template-columns: 1fr 1fr;

    > div {
      margin-top: 20px;
    }
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;

    > div {
      margin-right: 0 !important;
      margin-top: 20px;
    }
  }
`;

const handleChangePrice = (actualPrice, newValue, name, onChange) => {
  if (!actualPrice) {
    if (!isNaN(newValue) && newValue.length > 0 && newValue[0] === '0') {
      return onChange(name, Number(String(newValue.slice(1, newValue.length))));
    }
  }
  if (!newValue || isNaN(newValue)) {
    return onChange(name, 0);
  }

  return onChange(name, newValue);
};

const PreparationFilters = ({
  selections,
  options,
  onChange,
  dataCompetitors,
  onChangeCompetitors
}) => (
  <PreparationFiltersContainer>
    <Select
      selectedOption={selections.wine}
      onChange={(selectedOption) => {
        onChange('wine', selectedOption);
      }}
      isClearable={false}
      options={options.wine}
      label={I18n.t('primeur.compare.scatter.filters.wine')}
    />
    <Select
      selectedOption={selections.vintage}
      onChange={(selectedOption) => {
        onChange('vintage', selectedOption);
      }}
      isClearable={false}
      options={options.vintage}
      label={I18n.t('primeur.compare.scatter.filters.vintage')}
    />
    <Input
      type="modal"
      label={I18n.t('primeur.compare.scatter.filters.rivals')}
      value={`${selections.competitors.length} concurrents`}
      onChange={(labels) => onChangeCompetitors(labels)}
      data={dataCompetitors}
      selected={selections.competitors}
      styles={`.labelContainer{height:23px};.inputModalValueContainer{max-width:80%;}`}
    />
    <Select
      selectedOption={selections.appellation}
      onChange={(selectedOption) => onChange('appellation', selectedOption)}
      options={options.appellation}
      containerStyles={`width:240px;  :not(:last-child){margin-right:30px}`}
      label={I18n.t('primeur.compare.scatter.filters.appellation')}
      placeholder={I18n.t('notSelected')}
    />
    <Select
      selectedOption={selections.rank}
      onChange={(selectedOption) => onChange('rank', selectedOption)}
      options={options.rank}
      containerStyles={`width:240px;  :not(:last-child){margin-right:30px}`}
      label={I18n.t('primeur.compare.scatter.filters.rank')}
      placeholder={I18n.t('notSelected')}
    />
    <Select
      selectedOption={selections.color}
      onChange={(selectedOption) => onChange('color', selectedOption)}
      options={options.color}
      containerStyles={`width:240px;  :not(:last-child){margin-right:30px}`}
      label={I18n.t('primeur.compare.scatter.filters.color')}
      placeholder={I18n.t('placeholderAll2')}
    />

    <Input
      value={selections.minimumPrice}
      onChange={(selectedOption) =>
        handleChangePrice(
          selections.minimumPrice,
          selectedOption,
          'minimumPrice',
          onChange
        )
      }
      label={I18n.t('primeur.compare.scatter.filters.minPrice')}
      styles={`input{height:22px;background-color:transparent;border:0;border-bottom:1px solid rgba(134,142,150,0.3);}`}
    />
    <Input
      value={selections.maximumPrice}
      onChange={(selectedOption) =>
        handleChangePrice(
          selections.maximumPrice,
          selectedOption,
          'maximumPrice',
          onChange
        )
      }
      label={I18n.t('primeur.compare.scatter.filters.maxPrice')}
      styles={`input{height:22px;padding-left:0px;width:100%;background-color:transparent;border:0;border-bottom:1px solid rgba(134,142,150,0.3);}`}
    />
  </PreparationFiltersContainer>
);

export default PreparationFilters;
